import { PayloadAction } from '@reduxjs/toolkit';
import { BBox } from '@turf/helpers';
import { defaultBBox } from 'common/utils';
import { getValidFitBounds } from '../utils';

import { IState } from '../types/state';

const setActionStationsFitBounds = (
  state: IState,
  action: PayloadAction<BBox>,
) => {
  const fitBounds = action.payload.length ? action.payload : defaultBBox;
  state.actionStations.fitBounds = getValidFitBounds(fitBounds);
};

export default setActionStationsFitBounds;
